














import Vue, { PropOptions } from 'vue'

type TagSimpleVariant = 'default' | 'secondary'

export default Vue.extend({
  name: 'TagSimple',
  functional: true,
  props: {
    label: {
      type: String,
      required: true
    },
    extraCssClass: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'default'
    } as PropOptions<TagSimpleVariant>,
    isActive: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: () => {}
    } as PropOptions<(tag: string) => void>
  }
})
